import React from 'react';

type Props = { text: string; searchTerm: string };

const escapeRegExp = (term: string) => term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const HighlightWord: React.FC<Props> = ({ text, searchTerm }) => {
    try {
        // The term is literal text, not a pattern: "C++" or "SPR-001 (v2)" must match as typed.
        const term = escapeRegExp(searchTerm);
        const splitResult = text.split(new RegExp(`(?=${term})|(?<=${term})`, 'i'));

        const upperSearchTerm = searchTerm.toUpperCase();
        return (
            <>
                {splitResult.map((val, i) =>
                    val.toUpperCase() === upperSearchTerm ? (
                        // eslint-disable-next-line react/no-array-index-key
                        <b key={`${val}-${i}`}>{val}</b>
                    ) : (
                        // eslint-disable-next-line react/no-array-index-key
                        <React.Fragment key={`${val}-${i}`}>{val}</React.Fragment>
                    ),
                )}
            </>
        );
    } catch (e) {
        return <>{text}</>;
    }
};

export default React.memo(HighlightWord);
